import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, useEffect, useRef, useState } from 'react';
import { InView } from 'react-intersection-observer';

import { ProviderUid } from '@gem/call/CallProviders/callProviders.types';

import styles from './OpponentVideoView.styles.m.css';

export interface IOpponentVideoViewProps {
  className?: string;
  playVideo(container: HTMLDivElement): void;
  stopVideo(): void;
  uid: ProviderUid;
  isPlayingVideo: boolean;
  hasVideo: boolean;
  inverted?: boolean;
}

export const OpponentVideoView: FC<IOpponentVideoViewProps> = observer(
  ({ uid, hasVideo, isPlayingVideo, stopVideo, playVideo, className, inverted }) => {
    const [inView, setInView] = useState(false);
    const ref = useRef<HTMLDivElement | null>(null);

    const onChangeInView = (isInViewport: boolean): void => {
      setInView(isInViewport);
    };

    const inViewProps = {
      onChange: onChangeInView,
      threshold: 0.2,
      className: classNames(styles.container, className),
    };

    useEffect(() => {
      if (hasVideo && inView && ref.current) {
        playVideo(ref.current);
      }

      return () => {
        if (isPlayingVideo) {
          stopVideo();
        }
      };
    }, [ref, inView, uid]);

    return (
      <InView
        as="div"
        {...inViewProps}
      >
        <div
          ref={ref}
          className={classNames(styles.container, className, { [styles.inverted]: inverted })}
        />
      </InView>
    );
  }
);
